import { Box, TextField, Typography, type TextFieldProps } from '@mui/material';
import React from 'react';

export type ResearchExperienceTextFiledProps = {
  name: string;
  label: string;
  maxLength: number;
  value: string;
  enableEdit: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
} & TextFieldProps;

export const ResearchExperienceTextFiled: React.FunctionComponent<
  ResearchExperienceTextFiledProps
> = (props: ResearchExperienceTextFiledProps) => {
  const { label, maxLength, value, enableEdit, placeholder, ...others } = props;

  return (
    <Box padding={2}>
      <Box textAlign={'justify'}>{label}</Box>
      <TextField
        label={''}
        multiline
        minRows={4}
        fullWidth
        value={value}
        placeholder={placeholder}
        disabled={!enableEdit}
        inputProps={{ maxLength }}
        {...others}
        sx={{
          '& textarea::-webkit-scrollbar': {
            width: '10px',
            height: '10px',
            borderRadius: '5px',
          },
          '& textarea::-webkit-scrollbar-thumb': {
            backgroundColor: '#951D1D',
            borderRadius: '5px',
          },
          '& textarea::-webkit-scrollbar-track': {
            backgroundColor: '#F5F5F5',
            borderRadius: '5px',
          },
          marginTop: '8px',
          paddingX: '6px',
        }}
      />
      <Box textAlign={'right'}>
        <Typography variant="caption" color="textSecondary">
          Remaining characters:{' '}
          {value != null ? maxLength - value.length : maxLength}
        </Typography>
      </Box>
    </Box>
  );
};
